export default __webpack_public_path__ + "media/images/icons/consultancy-outline-9f8acacd3fffe0558fae682a83a79352.png";